import { useRemoveSavedFilter, useSavedFilters } from '@numistic/data'
import { useTranslation } from '@numistic/i18n'
import { Button } from '@numistic/ui'
import { createRoute, useNavigate } from '@tanstack/react-router'

import { MutationErrors } from '../../components/mutation-errors.js'
import { SpecimenList } from '../../collections/specimen-list.js'
import { requireSession } from '../../lib/guards.js'
import { rootRoute } from '../root.js'

/** «В поиске» и «На продаже» — предустановленные списки по статусу (docs/PLAN.md, раздел 8.1). */
function statusRoute(
  path: '/wanted' | '/for-sale',
  status: string,
  titleKey: 'collections.wanted' | 'collections.forSale',
) {
  return createRoute({
    getParentRoute: () => rootRoute,
    path,
    beforeLoad: ({ context, location }) => requireSession(context, location),
    component: function StatusList() {
      const { t } = useTranslation()
      return (
        <div className="grid gap-4">
          <h1 className="text-2xl font-semibold">{t(titleKey)}</h1>
          <SpecimenList query={{ status }} />
        </div>
      )
    },
  })
}

export const wantedRoute = statusRoute('/wanted', 'wanted', 'collections.wanted')
export const forSaleRoute = statusRoute('/for-sale', 'for_sale', 'collections.forSale')

export const savedViewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/views/$id',
  beforeLoad: ({ context, location }) => requireSession(context, location),
  component: SavedView,
})

function SavedView() {
  const { t } = useTranslation()
  const { id } = savedViewRoute.useParams()
  const views = useSavedFilters()
  const remove = useRemoveSavedFilter()
  const navigate = useNavigate()
  const view = views.data?.find((v) => v.id === id)
  if (!view) return null
  return (
    <div className="grid gap-4">
      <div className="flex items-center gap-3">
        <h1 className="mr-auto text-2xl font-semibold">{view.name}</h1>
        <Button
          variant="ghost"
          size="sm"
          onClick={() =>
            remove.mutate(id, { onSuccess: () => void navigate({ to: '/c', search: {} }) })
          }
        >
          {t('common.remove')}
        </Button>
      </div>
      <MutationErrors errors={[remove.error]} />
      <SpecimenList
        query={{
          filter: view.filter,
          status: view.params.status,
          tagId: view.params.tagId,
          collectionId: view.params.collectionId,
          includeChildren: view.params.includeChildren ? 'true' : undefined,
        }}
      />
    </div>
  )
}
